// Plausible loads via <script> tag injected di production (deferred to V1.1).
// Untuk F-01, trackEvent adalah no-op aman agar import tidak crash.

export function trackEvent(eventName, props = {}) {
  if (typeof window === 'undefined') return
  if (!window.plausible) return
  const safe = JSON.parse(
    JSON.stringify(props, (k, v) => {
      if (typeof v === 'string' && v.length > 200) return v.slice(0, 200)
      return v
    }),
  )
  window.plausible(eventName, { props: safe })
}
